import { render } from "./Instagallery.vue?vue&type=template&id=54a81d5a&scoped=true"
import script from "./Instagallery.vue?vue&type=script&lang=js"
export * from "./Instagallery.vue?vue&type=script&lang=js"

import "./Instagallery.vue?vue&type=style&index=0&id=54a81d5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54a81d5a"

export default script